import { render } from "./CompanyStatusCell.vue?vue&type=template&id=b283b9a6"
import script from "./CompanyStatusCell.vue?vue&type=script&lang=js"
export * from "./CompanyStatusCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__